import auth from '@/auth'
import HttpStatus from '@/components/http-status'
import * as Sentry from '@sentry/vue'
import { jwtDecode } from 'jwt-decode'

function isInvalidToken(error) {
  const status = error && error.response ? error.response.status : ''
  // const statusText = error.response.statusText
  // return (status === HttpStatus.UNAUTHORIZED && statusText === 'Invalid token')
  return status === HttpStatus.UNAUTHORIZED
}

function isExpiredToken(error) {
  const status = error && error.response ? error.response.status : ''
  const statusText = error && error.response ? error.response.statusText : ''

  return status === HttpStatus.UNAUTHORIZED && statusText === 'Token expired'
}

function refreshToken(request) {
  auth.logout()
}

function setUnauthorized(isUnauthorized) {
  try {
    localStorage.setItem('isUnauthorized', isUnauthorized ? 'true' : 'false')
  } catch (e) {
  }
}

function getIsUnauthorized() {
  try {
    return localStorage.getItem('isUnauthorized') === 'true'
  } catch (e) {
    return false
  }
}

function getCookie(name) {
  var value = '; ' + document.cookie
  var parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
}

function getAuthToken() {
  return getCookie('UniqApi.Token')
}

function parseArrayBufferErrorResponse(data) {
  let response = ''
  if ('TextDecoder' in window) {
    // Decode as UTF-8
    const dataView = new DataView(data)
    const decoder = new TextDecoder('utf8')
    response = JSON.parse(decoder.decode(dataView))
  } else {
    // Fallback decode as ASCII
    const decodedString = String.fromCharCode.apply(null, new Uint8Array(data))
    response = JSON.parse(decodedString)
  }
  return response
}

function sentryLogError(error, tag) {
  console.log('Error data:', (error && error.response) ? {
          status: error.response.status,
          statusText: statusText || 'N/A',
          headers: error.response.headers,
          data: error.response.data
        } : 'N/A')

  let statusText = 'N/A'
  try {
    if (error && error.response) {
      if (error.response.data && error.response.data.message) {
        statusText = error.response.data.message
      } else if (error.response.statusText) {
        statusText = error.response.statusText
      }
    }
    if (!statusText || (typeof statusText === 'string' && statusText.trim() === '')) {
      statusText = 'N/A'
    }
  } catch (ex) {
    statusText = 'N/A'
  }
  //if statusText contains 'token' then replace with 'token' with 'ticket' to avoid logging sensitive info
  if (typeof statusText === 'string' && statusText.toLowerCase().includes('token')) {
    statusText = statusText.replace(/token/gi, 'ticket')
  }
  try {
    console.log('Error data:', error && error.response && error.response.data)
    console.log('Error statusText:', error && error.response && error.response.statusText)
  } catch (ex) {
    // ignore logging errors
  }
  const token = getCookie('UniqApi.Token')
  const sessionId = getCookie('uniq.sessionid')
  const enableInDevelopment = process.env.NODE_ENV === 'production' || process.env.VUE_APP_SENTRY_ENABLE_IN_DEV === 'true'
  if (!token || !enableInDevelopment) {
    return
  }
  let decoded

  try {
    // Decode the token to get the payload object
    decoded = jwtDecode(token)
    if (!decoded.companyid || !decoded.userid) {
      return
    }
    const expdate = new Date(decoded.exp * 1000)
    Sentry.captureException(error, {
      tags: {
        feature: tag,
        companyId: decoded.companyid,
        userId: decoded.userid
      },
      extra: {
        JWTId: decoded.tokenid,
        exp: expdate,
        sessionid: sessionId || 'N/A',
        errorText: statusText || 'N/A',
        errorResponse: (error && error.response) ? {
          status: error.response.status,
          statusText: statusText || 'N/A',
          headers: error.response.headers,
          data: error.response.data
        } : 'N/A'
      }
    })
  } catch (error) {
    console.error(tag, error)
  }
}

export default {
  isInvalidToken,
  isExpiredToken,
  refreshToken,
  getAuthToken,
  parseArrayBufferErrorResponse,
  sentryLogError,
  setUnauthorized,
  getIsUnauthorized
}
